import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacement", "placementPrefix", "arrowClassName", "arrowStyles", "invertedArrow", "hideArrow", "popperClassName", "tag", "container", "modifiers", "boundariesElement", "onClosed", "onPlacementChange", "fade", "transition", "tooltip", "tooltipModifiers"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { Popper as ReactPopper } from "react-popper";
import { getTarget, targetPropType, DOMElement, tagPropType } from "./utils";
import Fade from "./o2-fade";

function noop() {}

var propTypes = {
  children: PropTypes.node.isRequired,
  popperClassName: PropTypes.string,
  placement: PropTypes.string,
  placementPrefix: PropTypes.string,
  arrowClassName: PropTypes.string,
  arrowStyles: PropTypes.object,
  hideArrow: PropTypes.bool,
  tag: tagPropType,
  invertedArrow: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  cssModule: PropTypes.object,
  offset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fallbackPlacement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  flip: PropTypes.bool,
  container: targetPropType,
  target: targetPropType.isRequired,
  modifiers: PropTypes.object,
  boundariesElement: PropTypes.oneOfType([PropTypes.string, DOMElement]),
  onClosed: PropTypes.func,
  onPlacementChange: PropTypes.func,
  fade: PropTypes.bool,
  transition: PropTypes.shape(Fade.propTypes),
  tooltip: PropTypes.bool,
  tooltipModifiers: PropTypes.object
};
var defaultProps = {
  boundariesElement: "scrollParent",
  placement: "auto",
  hideArrow: false,
  isOpen: false,
  offset: 0,
  fallbackPlacement: "flip",
  flip: true,
  container: "body",
  modifiers: {},
  onClosed: noop,
  onPlacementChange: noop,
  fade: true,
  transition: _objectSpread({}, Fade.defaultProps),
  tooltip: false,
  invertedArrow: false
};

var PopperContent = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(PopperContent, _React$PureComponent);

  function PopperContent(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.handlePlacementChange = _this.handlePlacementChange.bind(_assertThisInitialized(_this));
    _this.setTargetNode = _this.setTargetNode.bind(_assertThisInitialized(_this));
    _this.getTargetNode = _this.getTargetNode.bind(_assertThisInitialized(_this));
    _this.getRef = _this.getRef.bind(_assertThisInitialized(_this));
    _this.onClosed = _this.onClosed.bind(_assertThisInitialized(_this));
    _this.state = {
      isOpen: props.isOpen
    };
    return _this;
  }

  PopperContent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isOpen) {
      return {
        isOpen: props.isOpen
      };
    } else return null;
  };

  var _proto = PopperContent.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
      this._element.childNodes[0].focus();
    }
  };

  _proto.setTargetNode = function setTargetNode(node) {
    this.targetNode = node;
  };

  _proto.getTargetNode = function getTargetNode() {
    return this.targetNode;
  };

  _proto.getContainerNode = function getContainerNode() {
    return getTarget(this.props.container);
  };

  _proto.getRef = function getRef(ref) {
    this._element = ref;
  };

  _proto.handleO2Placement = function handleO2Placement(placement) {
    if (!this.props.invertedArrow) {
      return placement;
    }

    var o2Placement = placement;

    switch (placement) {
      case "top":
        o2Placement = "bottom";
        break;

      case "bottom":
        o2Placement = "top";
        break;

      case "left":
        o2Placement = "right";
        break;

      case "right":
        o2Placement = "left";
        break;

      default:
        o2Placement = placement;
    }

    return o2Placement;
  };

  _proto.handlePlacementChange = function handlePlacementChange(data) {
    if (this.state.placement !== data.placement) {
      this.setState({
        placement: data.placement,
        arrowPlacement: this.handleO2Placement(data.placement)
      });
    }

    this.props.onPlacementChange(data.placement);
    return data;
  };

  _proto.onClosed = function onClosed() {
    this.props.onClosed();
    this.setState({
      isOpen: false
    });
  };

  _proto.renderChildren = function renderChildren() {
    var _this$props = this.props,
        cssModule = _this$props.cssModule,
        children = _this$props.children,
        isOpen = _this$props.isOpen,
        flip = _this$props.flip,
        target = _this$props.target,
        offset = _this$props.offset,
        fallbackPlacement = _this$props.fallbackPlacement,
        placementPrefix = _this$props.placementPrefix,
        _arrowClassName = _this$props.arrowClassName,
        arrowStyles = _this$props.arrowStyles,
        invertedArrow = _this$props.invertedArrow,
        hideArrow = _this$props.hideArrow,
        _popperClassName = _this$props.popperClassName,
        tag = _this$props.tag,
        container = _this$props.container,
        modifiers = _this$props.modifiers,
        boundariesElement = _this$props.boundariesElement,
        onClosed = _this$props.onClosed,
        onPlacementChange = _this$props.onPlacementChange,
        fade = _this$props.fade,
        transition = _this$props.transition,
        tooltip = _this$props.tooltip,
        tooltipModifiers = _this$props.tooltipModifiers,
        attrs = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var arrowClassName = classNames("arrow", _arrowClassName);
    var placement = this.state.placement || attrs.placement;
    var arrowPlacement = this.state.arrowPlacement || attrs.placement;
    var placementFirstPart = arrowPlacement.split("-")[0];
    var popperClassName = classNames(_popperClassName, placementPrefix ? placementPrefix + "-" + placementFirstPart : placementFirstPart);

    var extendedModifiers = _objectSpread({
      offset: {
        offset: offset
      },
      flip: {
        enabled: flip,
        behavior: fallbackPlacement
      },
      preventOverflow: {
        boundariesElement: boundariesElement
      },
      update: {
        enabled: true,
        order: 950,
        fn: this.handlePlacementChange
      }
    }, modifiers);

    var popperTransition = _objectSpread(_objectSpread(_objectSpread({}, Fade.defaultProps), transition), {}, {
      baseClass: fade ? transition.baseClass : "",
      timeout: fade ? transition.timeout : 0
    });

    var getArrowPlacementStyle = function getArrowPlacementStyle(placement, background) {
      if (placement === undefined || placement === null) {
        return {};
      }

      if (placement.indexOf("top") !== -1) {
        return {
          borderTopColor: background
        };
      } else if (placement.indexOf("bottom") !== -1) {
        return {
          borderBottomColor: background
        };
      } else if (placement.indexOf("right") !== -1) {
        return {
          borderRightColor: background
        };
      } else {
        return {
          borderLeftColor: background
        };
      }
    };

    return /*#__PURE__*/React.createElement(Fade, _extends({}, popperTransition, attrs, {
      in: isOpen,
      onExited: this.onClosed,
      tag: tag
    }), /*#__PURE__*/React.createElement(ReactPopper, {
      referenceElement: this.targetNode,
      modifiers: extendedModifiers,
      placement: placement
    }, function (_ref) {
      var ref = _ref.ref,
          style = _ref.style,
          placement = _ref.placement,
          arrowProps = _ref.arrowProps;
      return /*#__PURE__*/React.createElement("div", {
        ref: ref,
        style: _objectSpread(_objectSpread({}, style), {}, {
          display: "block",
          marginTop: "" + (tooltip ? "8px" : ""),
          marginBottom: "" + (tooltip ? "8px" : "")
        }),
        className: popperClassName,
        "x-placement": placement
      }, tooltip && /*#__PURE__*/React.createElement("div", {
        className: tooltipModifiers.tooltipClassName + " " + placement,
        style: _objectSpread({
          position: "relative",
          display: "block"
        }, tooltipModifiers.tooltipStyles)
      }, children, /*#__PURE__*/React.createElement("span", {
        ref: arrowProps.ref,
        className: tooltipModifiers.arrowClassName,
        style: _objectSpread(_objectSpread({}, tooltipModifiers.tooltipArrowStyles), getArrowPlacementStyle(placement, tooltipModifiers.background))
      })), !tooltip && /*#__PURE__*/React.createElement(React.Fragment, null, children, !hideArrow && /*#__PURE__*/React.createElement("span", {
        ref: arrowProps.ref,
        className: arrowClassName,
        style: _objectSpread(_objectSpread({}, arrowStyles), arrowProps.style)
      })));
    }));
  };

  _proto.render = function render() {
    this.setTargetNode(getTarget(this.props.target));

    if (this.state.isOpen) {
      return this.props.container === "inline" ? this.renderChildren() : /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
        ref: this.getRef
      }, this.renderChildren()), this.getContainerNode());
    }

    return null;
  };

  return PopperContent;
}(React.PureComponent);

PopperContent.propTypes = propTypes;
PopperContent.defaultProps = defaultProps;
export default PopperContent;